export * from './lib/interfaces/detailed-checkbox-form-field-config.interface';
export * from './lib/interfaces/detailed-checkbox-template-options.interface';
export * from './lib/detailed-checkbox.module';
